import axios from "axios";
import Swal from "sweetalert2";
import { useEffect, useState, useRef } from "react";
import Cookies from "js-cookie";
import { QRCodeCanvas } from "qrcode.react";
import "canvas-toBlob";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Copy, Download, Video } from "lucide-react";

const InviteFriend = () => {
  const [uName, setUName] = useState("");
  const inviteLink = `https://postperty.com/register?ID=${uName}`;
  const qrCodeCanvasRef = useRef(null);
  const [dataBrochure, setDataBrochure] = useState("");
  const [isLoadingBrochure, setIsLoadingBrochure] = useState(false);
  const [brochureImgError, setBrochureImgError] = useState(false);
  const [checkPhone, setCheckPhone] = useState({ phone: null });
  const [textCheckPhoneNumber, setTextCheckPhoneNumber] = useState("กรุณากรอกเบอร์โทรศัพท์ 10 หลัก");

  useEffect(() => {
    const token = Cookies.get("jwt");
    axios
      .get(`${process.env.REACT_APP_API}/user/getDataProfile`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setUName(res.data.uname))
      .catch(console.error);
    getBrochure();
  }, []);

  function getBrochure() {
    setIsLoadingBrochure(true);
    axios
      .post(`${process.env.REACT_APP_API}/event/getBrochure`, { nothing: "" }, { headers: { Authorization: `Bearer ${Cookies.get("jwt")}` } })
      .then((res) => { setDataBrochure(res.data.BrochureURL); setIsLoadingBrochure(false); })
      .catch(() => setIsLoadingBrochure(false));
  }

  const copyLinkInvite = async () => {
    await navigator.clipboard.writeText(inviteLink);
    Swal.fire("คัดลอกสำเร็จ", "สามารถนำลิงก์นี้แชร์ให้เพื่อนของคุณได้", "success");
  };

  const saveQRCodeImage = () => {
    if (qrCodeCanvasRef.current) {
      const canvas = qrCodeCanvasRef.current.querySelector("canvas");
      if (canvas) {
        canvas.toBlob((blob) => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `postperty_invite_${uName}.png`;
          link.click();
        }, "image/png");
      }
    }
  };

  const checkPhoneNumber = (number) => {
    if (number && number.length === 10) {
      axios
        .post(`${process.env.REACT_APP_API}/user/checkPhoneNumber`, { checkPhoneNumber: number })
        .then((res) => setTextCheckPhoneNumber(res.data.Status ? "เบอร์นี้สมัครสมาชิกแล้ว" : "เบอร์นี้ยังไม่เป็นสมาชิก สามารถชวนได้"))
        .catch(console.error);
    } else {
      setTextCheckPhoneNumber("กรุณากรอกเบอร์โทร 10 หลัก");
    }
  };

  const downloadBrochureBack = async () => {
    const response = await fetch("/brochure/back.png");
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "postperty_brochure_back.png";
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleCopyLinkVideo = () => {
    navigator.clipboard.writeText("https://www.youtube.com/watch?v=CIm8ZCTFXOU");
    Swal.fire("คัดลอกลิงก์วิดีโอสำเร็จ", "สามารถนำลิงก์นี้แชร์ให้เพื่อนของคุณได้", "success");
  };

  const phoneOk = textCheckPhoneNumber.includes("ยังไม่เป็นสมาชิก");
  const phoneError = textCheckPhoneNumber.includes("สมัครสมาชิกแล้ว") || textCheckPhoneNumber.includes("แค่ 10");

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 py-8 space-y-4 lg:pt-24">

        {/* ── Header ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 px-5 py-4 flex items-center gap-3"
        >
          <Link to="/profiles">
            <div className="w-9 h-9 bg-gray-50 rounded-xl flex items-center justify-center border border-gray-100 hover:bg-gray-100 transition-colors flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
            </div>
          </Link>
          <div>
            <p className="text-xs text-gray-400 uppercase tracking-wider mb-0.5">โปรไฟล์</p>
            <h1 className="text-lg font-bold text-gray-900">แนะนำเพื่อน</h1>
          </div>
        </motion.div>

        {/* ── Check phone + Invite link ── */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

          {/* Check phone */}
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.04 }}
            className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 space-y-4"
          >
            <div>
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">ขั้นตอนที่ 1</p>
              <p className="text-sm font-semibold text-gray-800 mb-1">ตรวจสอบเบอร์เพื่อน</p>
              <p className="text-xs text-gray-400">ตรวจสอบว่าเพื่อนของคุณเป็นสมาชิกแล้วหรือยัง</p>
            </div>
            <div>
              <input
                type="tel"
                placeholder="เบอร์โทรศัพท์ 10 หลัก"
                onChange={(e) => { setCheckPhone({ phone: e.target.value }); checkPhoneNumber(e.target.value); }}
                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-blue-400 focus:bg-white transition-colors"
              />
              {checkPhone.phone && (
                <p className={`text-xs mt-1.5 font-medium ${phoneOk ? "text-emerald-600" : phoneError ? "text-red-500" : "text-gray-400"}`}>
                  {textCheckPhoneNumber}
                </p>
              )}
            </div>

            <div className="pt-3 border-t border-gray-100">
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">ขั้นตอนที่ 2</p>
              <p className="text-xs text-gray-500 mb-3">คัดลอกลิงก์และส่งต่อให้เพื่อนของคุณ</p>
              <button
                onClick={copyLinkInvite}
                className="w-full flex items-center gap-2 px-4 py-2.5 bg-gray-50 border border-dashed border-gray-300 rounded-xl text-xs text-gray-500 hover:bg-gray-100 hover:border-gray-400 transition-all text-left"
              >
                <Copy className="w-3.5 h-3.5 flex-shrink-0 opacity-50" />
                <span className="truncate font-mono">{inviteLink}</span>
              </button>
            </div>

            <div className="pt-3 border-t border-gray-100 flex items-center justify-between">
              <div>
                <p className="text-xs text-gray-400">User ID ของคุณ</p>
                <p className="text-lg font-bold text-gray-900 font-mono">{uName}</p>
              </div>
              <button
                onClick={copyLinkInvite}
                className="flex items-center gap-1.5 px-3 py-2 bg-blue-600 text-white text-xs font-semibold rounded-xl hover:bg-blue-700 transition-colors"
              >
                <Copy className="w-3.5 h-3.5" />
                คัดลอก
              </button>
            </div>
          </motion.div>

          {/* QR Code */}
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.06 }}
            className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 flex flex-col items-center justify-between"
          >
            <div className="w-full">
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">QR Code</p>
              <p className="text-sm font-semibold text-gray-800 mb-4">Scan เพื่อสมัครสมาชิก</p>
            </div>
            <div ref={qrCodeCanvasRef} className="p-4 bg-gray-50 border border-gray-100 rounded-2xl">
              <QRCodeCanvas value={inviteLink} bgColor="#f9fafb" size={150} />
            </div>
            <button
              onClick={saveQRCodeImage}
              className="w-full mt-4 flex items-center justify-center gap-2 py-2.5 bg-gray-50 border border-gray-200 text-gray-700 text-sm font-semibold rounded-xl hover:bg-gray-100 transition-colors"
            >
              <Download className="w-4 h-4" />
              บันทึก QR Code
            </button>
          </motion.div>
        </div>

        {/* ── Brochure ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.08 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden"
        >
          <div className="px-5 py-3.5 border-b border-gray-100">
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">โบรชัวร์</p>
          </div>

          {/* Front */}
          <div className="relative">
            {isLoadingBrochure ? (
              <div className="flex flex-col items-center justify-center h-52 gap-3 text-gray-400">
                <svg className="animate-spin w-8 h-8 text-blue-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                </svg>
                <p className="text-sm">กำลังสร้างโบรชัวร์...</p>
              </div>
            ) : dataBrochure ? (
              <div className="relative">
                {brochureImgError ? (
                  <div className="flex flex-col items-center justify-center h-52 gap-2 text-gray-400 text-sm">
                    <p>ไม่สามารถแสดงโบรชัวร์ได้</p>
                    <button
                      onClick={() => window.open(dataBrochure)}
                      className="flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-600 text-xs font-semibold rounded-full hover:bg-blue-100 transition-colors"
                    >
                      <Download className="w-3.5 h-3.5" />
                      เปิดโบรชัวร์ในแท็บใหม่
                    </button>
                  </div>
                ) : (
                  <>
                    <img
                      src={dataBrochure}
                      alt="Brochure Front"
                      className="w-full h-56 object-contain bg-gray-50"
                      onError={() => setBrochureImgError(true)}
                    />
                    <button
                      onClick={() => window.open(dataBrochure)}
                      className="absolute bottom-3 left-1/2 -translate-x-1/2 flex items-center gap-2 px-4 py-2 bg-black/60 backdrop-blur-sm text-white text-xs font-semibold rounded-full hover:bg-black/75 transition-colors whitespace-nowrap"
                    >
                      <Download className="w-3.5 h-3.5" />
                      ดาวน์โหลดโบรชัวร์ด้านหน้า
                    </button>
                  </>
                )}
              </div>
            ) : (
              <div className="flex items-center justify-center h-52 text-gray-400 text-sm">ไม่สามารถโหลดโบรชัวร์ได้</div>
            )}
          </div>

          <div className="border-t border-gray-100" />

          {/* Back */}
          <div className="relative">
            <img src="/brochure/back.png" alt="Brochure Back" className="w-full h-56 object-contain bg-gray-50" />
            <button
              onClick={downloadBrochureBack}
              className="absolute bottom-3 left-1/2 -translate-x-1/2 flex items-center gap-2 px-4 py-2 bg-black/60 backdrop-blur-sm text-white text-xs font-semibold rounded-full hover:bg-black/75 transition-colors whitespace-nowrap"
            >
              <Download className="w-3.5 h-3.5" />
              ดาวน์โหลดโบรชัวร์ด้านหลัง
            </button>
          </div>
        </motion.div>

        {/* ── Video link ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.1 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 px-5 py-4 flex items-center gap-4"
        >
          <div className="w-10 h-10 bg-red-50 rounded-xl flex items-center justify-center flex-shrink-0">
            <Video className="w-5 h-5 text-red-500" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-gray-800">วิดีโอแนะนำ Postperty</p>
            <p className="text-xs text-gray-400 mt-0.5">คัดลอกลิงก์วิดีโอส่งให้เพื่อน</p>
          </div>
          <button
            onClick={handleCopyLinkVideo}
            className="flex items-center gap-1.5 px-3 py-2 bg-gray-50 border border-gray-200 text-gray-700 text-xs font-semibold rounded-xl hover:bg-gray-100 transition-colors flex-shrink-0"
          >
            <Copy className="w-3.5 h-3.5" />
            คัดลอก
          </button>
        </motion.div>

        <div className="h-8" />
      </div>
    </div>
  );
};

export default InviteFriend;
